<template>
    <CContainer>
        <CRow class="mb-2">
            <CCol col="sm-6" class="pt-2">
                <label>Utilidad Total:</label>
                <strong class="ml-2">{{ formatter.format(profitPercentage, 2) }}%</strong>
            </CCol>
        </CRow>
        <CDataTable 
            hover 
            striped
            responsive 
            :items="records" 
            :fields="gridFields">
            <template #producto="{item}">
                <td>
                    <div>
                        {{ item.descripcion }}
                    </div>
                    <div>
                        <h4>{{ item.codigo }}</h4>
                    </div>
                </td>
            </template>
            <template #cantidad="{item}">
                <td>
                    <div class="d-flex justify-content-center">
                        {{ item.cantidad }}
                    </div>
                </td>
            </template>>
            <template #valores="{item}">
                <td>
                    <div class="d-flex justify-content-end">
                        {{ formatter.format(item.subtotal_Producto, 2) }}
                    </div>
                    <div class="d-flex justify-content-end">
                        {{ formatter.format(item.subtotal_Costo, 2) }}
                    </div>
                </td>
            </template>
            <template #utilidad="{item}">
                <td>
                    <div class="d-flex justify-content-end">
                        {{ formatter.format(item.utilidad_Producto, 2) }}
                    </div>
                    <div class="d-flex justify-content-end">
                        <strong :class="item.porcentaje_Utilidad > 0 ? 'text-success' : 'text-danger'">
                            {{ formatter.format(item.porcentaje_Utilidad, 2) }}%
                        </strong>
                    </div>
                </td>
            </template>
        </CDataTable>

        <CElementCover v-show="loading" />
    </CContainer>    
</template>

<script>
    import { formatter } from "../../general"
    import { dataGridMovimientosPedido } from "../../apiDataGrids"
    const gridFields = [
        {
            key: "producto",
            label: "Producto",
            _style: "text-align:center"
        },
        {
            key: "cantidad",
            label: "Cantidad",
            _style: "text-align:center"
        },
        {
            key: "valores",
            label: "Valores",
            _style: "text-align:center"
        },
        {
            key: "utilidad",
            label: "Utilidad",
            _style: "text-align:center"
        }
    ]

    export default {
        name: "OrderMovements",
        data() {
            return {
                formatter,
                loading: false,
                gridFields,
                records: [],
                profitQuote: 0,
                totalMerchandise: 0,
                totalCost: 0,
                profitPercentage: 0
            }
        },
        props: {
            idOrderQuote: String
        },
        methods: {
            async getData() {
                this.loading = true

                if (this.idOrderQuote) {
                    try {
                        const results = await dataGridMovimientosPedido(this, this.idOrderQuote)

                        let totalMercancia = 0
                        let totalCosto = 0

                        const newArray = results.map((reg) => {
                            let subtotalProducto = (reg.cantidad * reg.valor_Producto)
                            let subtotalCosto = (reg.cantidad * reg.costo_promedio)
                            let utilidadProducto = (subtotalProducto - subtotalCosto)
                            let porcentajeUtilidad = ((utilidadProducto * 100) / subtotalProducto)
                            
                            totalMercancia += subtotalProducto
                            totalCosto += subtotalCosto

                            return { ...reg, subtotal_Producto: subtotalProducto, subtotal_Costo: subtotalCosto, utilidad_Producto: utilidadProducto, porcentaje_Utilidad: porcentajeUtilidad }
                        })

                        const totalUtilidad = (totalMercancia - totalCosto)
                        this.profitPercentage = ((totalUtilidad * 100) / totalMercancia)

                        this.records = newArray
                    } catch (error) {
                        this.$store.commit("setAlert", {
                            color: "danger",
                            message: "No se pudo cargar los datos!",
                            show: 5
                        })
                    } finally {
                        this.loading = false
                    }
                }
            }
        },
        mounted() {
            this.getData()
        }
    }
</script>
